import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from 'axios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import userImage from '../assets/img/users/profile.jpg';
import companyImage from '../assets/img/users/placeholder.jpg';

class UploadPhotoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      photo: '',
      crop: {
        unit: 'px',
        width: 200,
        height: 200,
        x: 0,  // Add initial x
        y: 0,  // Add initial y
      },
      // crop: {
      //   unit: 'px',
      //   width: 200,
      //   height: 200,
      //   aspect: 1 / 1,
      //   minWidth: 200,
      //   minHeight: 200,
      // },
      croppedImageUrl: '',
      isUpload: false,
      croppedPhoto: '',
    };
  }

  handleImageChange = event => {
    if (event.target.files && event.target.files.length > 0) {
      let reader = new FileReader();
      let file = event.target.files[0];
      reader.onloadend = () => {
        this.setState({
          photo: reader.result,
          isUpload: !this.state.isUpload,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = e => {
    const { width, height } = e.currentTarget;
    
    // Center the crop area
    const crop = {
      unit: 'px',
      width: 200,
      height: 200,
      x: Math.max(0, (width - 200) / 2),
      y: Math.max(0, (height - 200) / 2),
    };
    
    this.setState({ crop }, () => {
      // Trigger crop complete after state is set
      this.makeClientCrop(crop);
    });
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        'newFile.jpeg',
      );
      this.setState({ croppedImageUrl: croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    //canvas.crossOrigin = 'Anonymous';
    const ctx = canvas.getContext('2d');
    //ctx.fillStyle = 'white';

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    const base64Image = canvas.toDataURL('image/png');

    this.setState({
      croppedPhoto: base64Image,
    });

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, 'image/png');
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    if (!this.state.croppedPhoto) {
      alert('No photo to upload');
      return;
    }

    const data = {
      session_key: user.session_key,
      userId: user.userId,
      name: user.name,
      contact: user.contact,
      photo: this.state.croppedPhoto,
    };

    axios
      .post(url + ':3000/v1/user/update-profile', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        StorageService.setSession('user_info', result.data);

        this.props.closeModal(
          <MdDone />,
          'Profile photo updated successfully.',
          'success',
          true,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  handleSubmitCompany = event => {
    event.preventDefault();

    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const selected_org = StorageService.getSession('selected_org');

    if (!this.state.croppedPhoto) {
      alert('No photo to upload');
      return;
    }

    const data = {
      session_key: user.session_key,
      CompanyID: selected_org.CompanyID,
      Logo: this.state.croppedPhoto,
    };

    axios
      .post(url + ':3000/v1/company/updatePhoto', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        selected_org.CompanyLogo = result.data.CompanyLogo;
        StorageService.setSession('selected_org', selected_org);

        this.props.closeModal(
          <MdDone />,
          'Company logo updated successfully.',
          'success',
          true,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    return (
      <Form
        className="AuthForm"
        onSubmit={
          this.props.data.isCompanyLogo
            ? this.handleSubmitCompany
            : this.handleSubmit
        }
      >
        <ModalHeader toggle={this.props.onToggleModal()}>
          {this.props.data.isCompanyLogo ? 'Company Logo' : 'Profile Photo'}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div className="mb-3 text-center">
                <Avatar
                  className="mx-auto profile-img"
                  src={
                    this.state.croppedImageUrl
                      ? this.state.croppedImageUrl
                      : this.props.data.isCompanyLogo
                      ? companyImage
                      : userImage
                  }
                />
              </div>

              {!this.state.isUpload && (
                <div className="text-center">
                  <Input
                    type="file"
                    name="file"
                    id="file"
                    className="ps-input-file"
                    onChange={this.handleImageChange}
                  />
                  <Label for="file">
                    <MdCameraAlt /> Upload
                  </Label>
                </div>
              )}

              {this.state.photo && (
                <ReactCrop
                  crop={this.state.crop}
                  onChange={this.onCropChange}
                  onComplete={this.onCropComplete}
                  aspect={1}
                  minWidth={200}
                  minHeight={200}
                >
                  <img 
                    ref={ref => (this.imageRef = ref)}
                    alt="Crop me"
                    src={this.state.photo}
                    onLoad={this.onImageLoaded}
                  />
                </ReactCrop>
                // <ReactCrop
                //   src={this.state.photo}
                //   crop={this.state.crop}
                //   ruleOfThirds
                //   onImageLoaded={this.onImageLoaded}
                //   onComplete={this.onCropComplete}
                //   onChange={this.onCropChange}
                // />
              )}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Discard
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default UploadPhotoForm;
